import { useMemo, useSyncExternalStore } from 'react';
import { createDraft } from '../../../packages/shared/browser-recovery/drafts';
export function useDraft<T extends object>(key: string, baseline: string, initial: T, valid: (value: unknown) => value is T) {
  const store = useMemo(() => createDraft(key, baseline, initial, valid), [key, baseline]);
  const state = useSyncExternalStore(store.subscribe, store.snapshot);
  const field = <K extends keyof T>(name: K): [T[K], (value: T[K]) => void] => [state.value[name], value => store.set(current => ({ ...current, [name]: value }))];
  return { ...state, ...store, field, locked: state.stale || state.changedElsewhere || state.unreadable };
}
